class AnalyticsController {
  constructor(AnalyticsService, $q) {
    "ngInject"

    this.analyticsService = AnalyticsService;
    this.$q = $q;
  }

  $onInit() {
    this.isLoading = true;

    const registrationsOvertimePromise = this.analyticsService.getRegistrationsOverTimeData();
    const recentRegistrationsPromise = this.analyticsService.getRecentRegistrationsData();
    const recentNSWRegistrationsPromise = this.analyticsService.getRecentNSWRegistrationsData();
    const recentVICRegistrationsPromise = this.analyticsService.getRecentVICRegistrationsData();
    const recentQLDRegistrationsPromise = this.analyticsService.getRecentQLDRegistrationsData();
    const accountApprovalOverTimePromise = this.analyticsService.getAccountApprovalOverTime();
    const getGeneralStatsPromise = this.analyticsService.getGeneralStatsData();
    const clientProfileItemsPerYearPromise = this.analyticsService.getClientProfileItemsPerYearData();
    const providerProfileItemsPerYearPromise = this.analyticsService.getProviderProfileItemsPerYearData();
    const getNSWRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getNSWRegistrationsByRegionOverTimeData();
    const getVICRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getVICRegistrationsByRegionOverTimeData();
    const getQLDRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getQLDRegistrationsByRegionOverTimeData();
    const getNZRegistrationsByRegionOverTimeDataPromise = this.analyticsService.getNZRegistrationsByRegionOverTimeData();
    const payingCustomersPromise = this.analyticsService.getPayingCustomersData();
    const customerRedemptionsOverTimePromise = this.analyticsService.getCustomerRedemptionsOverTime();
    const getRegistrationsYearOverYearPromise = this.analyticsService.getRegistrationsYearOverYearData();
    const getRegistrationsFinancialYearOverYearPromise = this.analyticsService.getRegistrationsFinancialYearOverYearData();
    const topRegistrationsPromise = this.analyticsService.getTopRegistrationsData();
    const registrationsByStatePromise = this.analyticsService.getRegistrationsByStateData();
    const recentAppDownloadsPromise = this.analyticsService.getRecentAppDownloadsData();
    const accountRatingsPromise = this.analyticsService.getAccountRatingsBreakdownData();

    this.$q.all([payingCustomersPromise, customerRedemptionsOverTimePromise, registrationsOvertimePromise, recentRegistrationsPromise, recentNSWRegistrationsPromise, recentVICRegistrationsPromise, recentQLDRegistrationsPromise, accountApprovalOverTimePromise, getGeneralStatsPromise, clientProfileItemsPerYearPromise, providerProfileItemsPerYearPromise, getNSWRegistrationsByRegionOverTimeDataPromise, getVICRegistrationsByRegionOverTimeDataPromise, getQLDRegistrationsByRegionOverTimeDataPromise, getRegistrationsYearOverYearPromise, topRegistrationsPromise, registrationsByStatePromise, getNZRegistrationsByRegionOverTimeDataPromise, getRegistrationsFinancialYearOverYearPromise, recentAppDownloadsPromise, accountRatingsPromise]).then(data => {

      const [payingCustomersResponse, customerRedemptionsOverTimeResponse, registrationsOvertimeResponse, recentRegistrationsResponse, recentNSWRegistrationsResponse, recentVICRegistrationsResponse, recentQLDRegistrationsResponse, accountApprovalOverTimeResponse, getGeneralStatsResponse, clientProfileItemsPerYearResponse, providerProfileItemsPerYearResponse, getNSWRegistrationsByRegionOverTimeDataResponse, getVICRegistrationsByRegionOverTimeDataResponse, getQLDRegistrationsByRegionOverTimeDataResponse, getRegistrationsYearOverYearResponse, topRegistrationsResponse, registrationsByStateResponse, getNZRegistrationsByRegionOverTimeResponse, getRegistrationsFinancialYearOverYearResponse, recentAppDownloadsResponse, accountRatingsResponse] = data;

      this.setRegistrationsOverTimeChartOptions(registrationsOvertimeResponse);
      this.setRegistrationsYearOverYearChartOptions(getRegistrationsYearOverYearResponse, getRegistrationsFinancialYearOverYearResponse);

      this.setRecentRegistrationsChartOptions(recentRegistrationsResponse);
      this.setRecentAppDownloadsChartOptions(recentAppDownloadsResponse);
      this.setTopRegistrationsChartOptions(topRegistrationsResponse);
      this.setRecentNSWRegistrationsChartOptions(recentNSWRegistrationsResponse);
      this.setRecentVICRegistrationsChartOptions(recentVICRegistrationsResponse);
      this.setRecentQLDRegistrationsChartOptions(recentQLDRegistrationsResponse);

      this.setRedemptionsAndNewPayingCustomersOverTimeOptions(payingCustomersResponse, customerRedemptionsOverTimeResponse);

      this.setAccountApprovalOverTimeOptions(accountApprovalOverTimeResponse);

      this.setGeneralStatsOptions(getGeneralStatsResponse);

      this.setClientProfileItemsPerYearOptions(clientProfileItemsPerYearResponse);

      this.setProviderProfileItemsPerYearOptions(providerProfileItemsPerYearResponse);

      this.setRegistrationsByRegionOverTimeChartOptions(getNSWRegistrationsByRegionOverTimeDataResponse, getVICRegistrationsByRegionOverTimeDataResponse, getQLDRegistrationsByRegionOverTimeDataResponse, registrationsByStateResponse, getNZRegistrationsByRegionOverTimeResponse);

      this.setAccountRatingsOverTimeOptions(accountRatingsResponse);
      this.isLoading = false;
    })

  }

  setRedemptionsAndNewPayingCustomersOverTimeOptions(redemptions, newPayingCustomers) {
      var format = "{0}";
      var template = "#: text # - Customers: #: series.totalCount #";
      var dateFormat = {months: "MMM 'yy"};

      var series = [];
      series.push(newPayingCustomers.series[0]);
      series.push(redemptions.series[0]);

      this.redemptionsAndNewPayingCustomersOverTimeOptions = this.analyticsService.getChartOptions("Redemptions & New Paying Customers", series, redemptions.categories, format, template, dateFormat);
  }

  setRegistrationsOverTimeChartOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {months: "MMM 'yy"};

    this.registrationsOverTimeOptions = this.analyticsService.getChartOptions("Registrations Over Time", data.series, data.categories, format, template, dateFormat);
  }

  setAccountRatingsOverTimeOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {months: "MMM 'yy"};

    this.accountRatingsOverTimeOptions = this.analyticsService.getChartOptions("Account Ratings Over Time", data.series, data.categories, format, template, dateFormat);
  }

  setRegistrationsYearOverYearChartOptions(data, fdata) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {months: "MMM"};

    this.registrationsYearOverYearOptions = this.analyticsService.getChartOptions("Registrations YoY", data.series, data.categories, format, template, dateFormat);
    this.registrationsFinancialYearOverYearOptions = this.analyticsService.getChartOptions("Registrations FYoY", fdata.series, fdata.categories, format, template, dateFormat);
    this.registrationsFinancialYearOverYearSummaryOptions = this.getColumnChartOptions("Registrations by Financial Year", fdata);
  }

  getColumnChartOptions = (title, data) => {

    var categories = [];

    var ds = [];
    // var seriesColors = [
    //     "#007bc3",
    //     "#76b800",
    //     "#ffae00",
    //     "#ef4c00",
    //     "#a419b7",
    //     "#430b62"
    // ];

    var seriesColors = [
      "#007bc3",
      "#007bc3",
      "#007bc3",
      "#007bc3",
      "#007bc3",
      "#76b800",
      "#a419b7",
      "#430b62"
  ];

    data.series.forEach( (s, index) => {
        ds.push({
            data: s.totalCount,
            category: s.name,
            color: seriesColors[index]
        });
        categories.push(s.name);
    });

    return {
        title: {
            text: title,
            position: "bottom"
        },
        dataSource: {
            data: ds
        },
        theme: "silver",
        legend: {
            position: "top"
        },
        seriesDefaults: {
            type: "column",
            labels: {
                visible: true,
                format: "{0:n0}",
                background: "transparent"
            }
        },
        series: [{
            field: "data",
            categoryField: "category",
            colorField: "color"
        }],
        valueAxis: {
            format: "{0:n0}",
            majorGridLines: {
                visible: true
            },
            visible: false
        },
        categoryAxis: {
            majorGridLines: {
                visible: true
            },
            line: {
                visible: false
            }
        }
    };
}

  setRegistrationsByRegionOverTimeChartOptions(nswData, vicData, qldData, stateData, nzData) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {months: "MMM 'yy"};

    this.nswRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("NSW Registrations By Region", nswData.series, nswData.categories, format, template, dateFormat);
    this.vicRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("VIC Registrations By Region", vicData.series, vicData.categories, format, template, dateFormat);
    this.qldRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("QLD Registrations By Region", qldData.series, qldData.categories, format, template, dateFormat);
    this.nzRegistrationsByRegionOverTimeOptions = this.analyticsService.getChartOptions("NZ Registrations By Region", nzData.series, nzData.categories, format, template, dateFormat);

    var parsedCats = stateData.categories.map( (item) => kendo.toString(new Date(item), "yy-MM"));
    const tooltipTemplate = (e) => {
      const date = kendo.toString(new Date(e.category), "MMM yyyy");
      var idx = parsedCats.indexOf(kendo.toString(e.category, "yy-MM"));
      var totalSeries = stateData.series[0];
      var total = totalSeries.data[idx];

      var ratio = kendo.toString(e.dataItem.value / total, "p");
      return date + ' - ' + ratio;
    };

    var stateSeries = [];
    stateSeries.push(stateData.series[0]);
    stateSeries.push(stateData.series[1]);
    stateSeries.push(stateData.series[2]);
    stateSeries.push(stateData.series[3]);
    stateSeries.push(stateData.series[4]);
    stateSeries.push(stateData.series[5]);
    this.registrationsByStateOverTimeOptions =  this.analyticsService.getChartOptions("Registrations By State", stateSeries, stateData.categories, format, template, dateFormat, tooltipTemplate);

    var countrySeries = [];
    countrySeries.push(stateData.series[6]);
    countrySeries.push(stateData.series[7]);
    this.registrationsByCountryOverTimeOptions =  this.analyticsService.getChartOptions("Registrations By Country", countrySeries, stateData.categories, format, template, dateFormat, tooltipTemplate);
  }

  setRecentAppDownloadsChartOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {days: "ddd dd"};
    const downloadsByDeviceSeries = [];
    downloadsByDeviceSeries.push(data.series[0]);
    downloadsByDeviceSeries.push(data.series[1]);
    downloadsByDeviceSeries.push(data.series[2]);

    const downloadsByCountrySeries = [];
    downloadsByCountrySeries.push(data.series[0]);
    downloadsByCountrySeries.push(data.series[3]);
    downloadsByCountrySeries.push(data.series[4]);

    const regsByCountrySeries = [];
    regsByCountrySeries.push(data.series[5]);
    regsByCountrySeries.push(data.series[6]);
    regsByCountrySeries.push(data.series[7]);

    this.recentAppDownloadsByDeviceOptions = this.analyticsService.getChartOptions("App Downloads by Device", downloadsByDeviceSeries, data.categories, format, template, dateFormat, null, "days");
    this.recentAppDownloadsByCountryOptions = this.analyticsService.getChartOptions("App Downloads by Country", downloadsByCountrySeries, data.categories, format, template, dateFormat, null, "days");
    this.recentDeviceRegistrationsByCountryOptions = this.analyticsService.getChartOptions("App Registrations by Device", regsByCountrySeries, data.categories, format, template, dateFormat, null, "days");
  }

  setRecentRegistrationsChartOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {days: "ddd dd"};

    var recentRegSeries = [];
    recentRegSeries.push(data.series[0]);
    recentRegSeries.push(data.series[1]);
    recentRegSeries.push(data.series[2]);
    recentRegSeries.push(data.series[34]);

    var recentRegByDeviceSeries = [];
    recentRegByDeviceSeries.push(data.series[0]);
    recentRegByDeviceSeries.push(data.series[3]);
    recentRegByDeviceSeries.push(data.series[4]);
    recentRegByDeviceSeries.push(data.series[28]);

    var recentRegByTypeByDeviceSeries = [];
    recentRegByTypeByDeviceSeries.push(data.series[5]);
    recentRegByTypeByDeviceSeries.push(data.series[6]);
    recentRegByTypeByDeviceSeries.push(data.series[7]);
    recentRegByTypeByDeviceSeries.push(data.series[8]);
    recentRegByTypeByDeviceSeries.push(data.series[29]);
    recentRegByTypeByDeviceSeries.push(data.series[30]);

    var recentRegBySourceSeries = [];
    recentRegBySourceSeries.push(data.series[18]);
    recentRegBySourceSeries.push(data.series[19]);
    recentRegBySourceSeries.push(data.series[20]);
    recentRegBySourceSeries.push(data.series[21]);
    recentRegBySourceSeries.push(data.series[22]);

    this.recentRegistrationsOptions = this.analyticsService.getChartOptions("Recent Registrations", recentRegSeries, data.categories, format, template, dateFormat, null, "days");

    this.recentRegistrationsByDeviceOptions = this.analyticsService.getChartOptions("Recent Registrations by Device", recentRegByDeviceSeries, data.categories, format, template, dateFormat, null, "days");

    this.recentRegistrationsByTypeByDeviceOptions = this.analyticsService.getChartOptions("Recent Registrations by Type by Device", recentRegByTypeByDeviceSeries, data.categories, format, template, dateFormat, null, "days");

    this.recentRegistrationsBySourceOptions = this.analyticsService.getChartOptions("Recent Registrations - Acquisition Source", recentRegBySourceSeries, data.categories, format, template, dateFormat, null, "days");

    var recentRegNzSeries = [];
    recentRegNzSeries.push(data.series[9]);
    recentRegNzSeries.push(data.series[10]);
    recentRegNzSeries.push(data.series[11]);
    recentRegNzSeries.push(data.series[35]);

    var recentRegByDeviceNzSeries = [];
    recentRegByDeviceNzSeries.push(data.series[9]);
    recentRegByDeviceNzSeries.push(data.series[12]);
    recentRegByDeviceNzSeries.push(data.series[13]);
    recentRegByDeviceNzSeries.push(data.series[31]);

    var recentRegByTypeByDeviceNzSeries = [];
    recentRegByTypeByDeviceNzSeries.push(data.series[14]);
    recentRegByTypeByDeviceNzSeries.push(data.series[15]);
    recentRegByTypeByDeviceNzSeries.push(data.series[16]);
    recentRegByTypeByDeviceNzSeries.push(data.series[17]);
    recentRegByTypeByDeviceNzSeries.push(data.series[32]);
    recentRegByTypeByDeviceNzSeries.push(data.series[33]);

    var recentRegBySourceNzSeries = [];
    recentRegBySourceNzSeries.push(data.series[23]);
    recentRegBySourceNzSeries.push(data.series[24]);
    recentRegBySourceNzSeries.push(data.series[25]);
    recentRegBySourceNzSeries.push(data.series[26]);
    recentRegBySourceNzSeries.push(data.series[27]);

    this.recentRegistrationsNzOptions = this.analyticsService.getChartOptions("Recent Registrations", recentRegNzSeries, data.categories, format, template, dateFormat, null, "days");

    this.recentRegistrationsByDeviceNzOptions = this.analyticsService.getChartOptions("Recent Registrations by Device", recentRegByDeviceNzSeries, data.categories, format, template, dateFormat, null, "days");

    this.recentRegistrationsByTypeByDeviceNzOptions = this.analyticsService.getChartOptions("Recent Registrations by Type by Device", recentRegByTypeByDeviceNzSeries, data.categories, format, template, dateFormat, null, "days");

    this.recentRegistrationsBySourceNzOptions = this.analyticsService.getChartOptions("Recent Registrations - Acquisition Source", recentRegBySourceNzSeries, data.categories, format, template, dateFormat, null, "days");  }

  setTopRegistrationsChartOptions(data) {
    this.topRegistrationsOptions = {
        title: {
            text: 'Hall of Fame'
        },
        theme: "silver",
        legend: {
            visible: false
        },
        seriesDefaults: {
            type: "column",
            labels: {
              visible: true,
              format: "{0:n0}"
            }
        },
        series: data.series,
        valueAxis: {
            labels: {
                format: "{0:n0}"
            },
            line: {
                visible: false
            },
        },
        categoryAxis: {
            categories: data.categories,
            labels: {
                template: "#= kendo.toString(new Date(value), 'ddd d MMM yy') #",
            },
            line: {
                visible: false
            },
        },
        tooltip: {
            visible: true,
            format: "{0}%",
            template: "#= series.name #: #= kendo.toString(value, 'n0') #"
        }
    };
  }

  setRecentNSWRegistrationsChartOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {days: "ddd dd"};

    this.recentNSWRegistrationsOptions = this.analyticsService.getChartOptions("Recent NSW Registrations", data.series, data.categories, format, template, dateFormat, null, "days");
  }

  setRecentVICRegistrationsChartOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {days: "ddd dd"};

    this.recentVICRegistrationsOptions = this.analyticsService.getChartOptions("Recent VIC Registrations", data.series, data.categories, format, template, dateFormat, null, "days");
  }

  setRecentQLDRegistrationsChartOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {days: "ddd dd"};

    this.recentQLDRegistrationsOptions = this.analyticsService.getChartOptions("Recent QLD Registrations", data.series, data.categories, format, template, dateFormat, null, "days");
  }

  setAccountApprovalOverTimeOptions(data) {
    var format = "{0}";
    var template = "#: text #: #: series.totalCount #";
    var dateFormat = {days: "ddd dd"};

    var parsedCats = data.categories.map( (item) => kendo.toString(new Date(item), "yy-MM"));
    const tooltipTemplate = (e) => {
      var idx = parsedCats.indexOf(kendo.toString(e.category, "yy-MM"));

      var activeSeries = data.series[e.series.index];
      var relatedSeries;
      if (e.series.index < 2)
        relatedSeries = data.series[e.series.index == 0 ? 1 : 0];
      else
        relatedSeries = data.series[e.series.index == 2 ? 3 : 2];
      var relatedItem = relatedSeries.data[idx];
      var total = e.dataItem.value + relatedItem;

      var ratio = kendo.toString(e.dataItem.value / total, "p");
      return ratio;
    };

    this.accountApprovalOverTimeOptions = this.analyticsService.getChartOptions("Pending vs Approved Accounts", data.series, data.categories, format, template, dateFormat, tooltipTemplate);
  }

  setGeneralStatsOptions(data) {
    var clientJourneySet = data.series[0];
    this.clientJourneyOptions = this.analyticsService.getFunnelChartOptions(clientJourneySet.name, clientJourneySet.data, this.analyticsService.getPercentage);

    var providerJourneySet = data.series[1];
    this.providerJourneyOptions = this.analyticsService.getFunnelChartOptions(providerJourneySet.name, providerJourneySet.data, this.analyticsService.getPercentage);

    var revenueAtGlanceSet = data.series[2];
    var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueAtGlanceSet.name, revenueAtGlanceSet.totalCount, revenueAtGlanceSet.totalRevenue);
    var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
    this.revenueAtGlanceOptions = this.analyticsService.getDonutChartOptions(revenueAtGlanceSet, titleFormat, labelFormat);

    var revenueByFrequencySet = data.series[4];
    var titleFormat = kendo.format("{0} - TRX: {1}, Total: {2:c0}", revenueByFrequencySet.name, revenueByFrequencySet.totalCount, revenueByFrequencySet.totalRevenue);
    var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:c0}', dataItem.value)#";
    this.revenueByFrequencyOptions = this.analyticsService.getDonutChartOptions(revenueByFrequencySet, titleFormat, labelFormat);

    var jobDistributionSet = data.series[3];
    titleFormat = kendo.format("{0} - TRX: {1}", jobDistributionSet.name, jobDistributionSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Jobs', dataItem.value)#";
    this.jobDistributionOptions = this.analyticsService.getDonutChartOptions(jobDistributionSet, titleFormat, labelFormat);

    var revenueBySourceSet = data.series[5];
    titleFormat = kendo.format("{0} - Parents: {1}", revenueBySourceSet.name, revenueBySourceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Parents', dataItem.value)#";
    this.revenueBySourceOptions = this.analyticsService.getDonutChartOptions(revenueBySourceSet, titleFormat, labelFormat);

    var redemptionsBySourceSet = data.series[6];
    titleFormat = kendo.format("{0}", redemptionsBySourceSet.name, redemptionsBySourceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) #";
    this.redemptionsBySourceOptions = this.analyticsService.getDonutChartOptions(redemptionsBySourceSet, titleFormat, labelFormat);

    var jobsByDeviceSet = data.series[7];
    titleFormat = kendo.format("{0} - TRX: {1}", jobsByDeviceSet.name, jobsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p0}', value) #";
    this.jobsByDeviceOptions = this.analyticsService.getDonutChartOptions(jobsByDeviceSet, titleFormat, labelFormat);

    var registrationsByDeviceSet = data.series[8];
    titleFormat = kendo.format("{0}", registrationsByDeviceSet.name, registrationsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) #";
    this.registrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(registrationsByDeviceSet, titleFormat, labelFormat);

    var parentRegistrationsByDeviceSet = data.series[9];
    titleFormat = kendo.format("{0}", parentRegistrationsByDeviceSet.name, parentRegistrationsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) #";
    this.parentRegistrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(parentRegistrationsByDeviceSet, titleFormat, labelFormat);

    var helperRegistrationsByDeviceSet = data.series[10];
    titleFormat = kendo.format("{0}", helperRegistrationsByDeviceSet.name, helperRegistrationsByDeviceSet.totalCount);
    labelFormat = "#= category # - #= kendo.format('{0:p2}', value) #";
    this.helperRegistrationsByDeviceOptions = this.analyticsService.getDonutChartOptions(helperRegistrationsByDeviceSet, titleFormat, labelFormat);

    var helpersByJobTypeSet = data.series[11];
    if (helpersByJobTypeSet) {
      titleFormat = kendo.format("{0}", helpersByJobTypeSet.name, helpersByJobTypeSet.totalCount);
      labelFormat = "#= category # - #= kendo.format('{0:p2}', value) # \n #=kendo.format('{0:n0} Helpers', dataItem.value)#";
      this.helpersByJobTypeSetOptions = this.analyticsService.getDonutChartOptions(helpersByJobTypeSet, titleFormat, labelFormat);
    }
  }

  setClientProfileItemsPerYearOptions(data) {
    this.clientProfileItemsPerYearOptions = this.analyticsService.getColumnChartOptions("Missing Items in Parent Accounts ", data);
  }

  setProviderProfileItemsPerYearOptions(data) {
    this.providerProfileItemsPerYearOptions = this.analyticsService.getColumnChartOptions("Missing Items in Helper Accounts ", data);
  }

}

export default AnalyticsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-users/analytics-users.controller.js
 **/